import { lazy } from 'react';

const calculator = lazy(() => import('./Calculator'));

export { calculator };
